import { defineMessages } from 'react-intl';

export const mcpPermissionsMessages = defineMessages({
  sectionTitle: {
    id: 'oauth.mcp.permissions.sectionTitle',
    defaultMessage: 'Permissions',
    description: 'Section heading for MCP permissions',
  },
  editPermissions: {
    id: 'oauth.mcp.permissions.editPermissions',
    defaultMessage: 'Edit permissions',
    description: 'Link text to enter edit-permissions mode',
  },
  toolsetsSelected: {
    id: 'oauth.mcp.permissions.toolsetsSelected',
    defaultMessage: '{selected} out of {total} permissions selected',
    description:
      'Counter shown in footer when editing permissions; {selected} and {total} are numbers',
  },
  emptyStateHeading: {
    id: 'oauth.mcp.permissions.emptyStateHeading',
    defaultMessage: 'Permissions are blocked for this {productUnit}',
    description:
      'Heading when the workspace policy returns no permission toolsets; {productUnit} is "Trello workspace" or "Atlassian site"',
  },
  emptyStateDescription: {
    id: 'oauth.mcp.permissions.emptyStateDescription',
    defaultMessage:
      'Contact your organization admin to request access or see <howPermissionsLink>how permissions are managed</howPermissionsLink>',
    description:
      'Body copy for blocked permissions empty state, with embedded link to documentation about MCP permission management',
  },
});

export const mcpBannerMessages = defineMessages({
  editWarningTitle: {
    id: 'oauth.mcp.banner.editWarning.title',
    defaultMessage: 'Unselected permissions will limit {product} MCP features',
    description:
      'Warning banner title when the user has deselected one or more MCP permission toolsets; {product} is either "Atlassian" or "Trello"',
  },
  editWarningBody: {
    id: 'oauth.mcp.banner.editWarning.body',
    defaultMessage:
      "If you later want to use a feature that requires a permission you didn't grant, you'll need to disconnect and reconnect {product} MCP to update your permissions.",
    description:
      'Warning banner body when the user has deselected one or more MCP permission toolsets; {product} is either "Atlassian" or "Trello"',
  },
  editWarningDismiss: {
    id: 'oauth.mcp.banner.editWarning.dismiss',
    defaultMessage: 'Understood',
    description:
      'Dismiss button label on the warning banner when the user has deselected MCP permission toolsets',
  },
  inboxPlannerDisabledMessage: {
    id: 'oauth.mcp.banner.inboxPlannerDisabled.message',
    defaultMessage:
      'Inbox and Planner permissions are disabled since this workspace is not owned by your organisation. Permission for this workspace and its boards can still proceed.',
    description:
      "Info banner shown when inbox/planner scopes are excluded because the selected Trello workspace is outside the user's managing organization",
  },
});
